import { createStore } from "vuex";
import { Actions, Mutations, Getters } from "@/store/enums/rootEnums";
import { Module as hosterModule, hosterModules } from "@/store/modules/hosterModules";
import { Module as participationModule, participationModules } from "@/store/modules/participationModules";
import { Module as homeModule, homeModules } from "@/store/modules/homeModules";
import { Module as exposedModule, exposedModules } from "@/store/modules/exposedModules";
import { String } from "lodash";
import User from "@/core/models/share/user.interface";
import AuthService from "@/core/services/Authservice";
import ApiService from "@/core/services/ApiService";
import { config } from "@/core/config";
import axios from "axios";
import apiEnums from "@/core/services/apiEnums";

export default createStore({
  state: {
    isLoad: false,
    user: <User>{
      MemberId: "",
      Name: "",
      Email: "",
      Department: "",
      // Department: "資訊工程部",
      // Email: "yishan1313@realtek.com",
      // MemberId: "ff85f55e-b1de-43aa-b3c2-6e64ba44dcdc",
      // Name: "莊宜珊",
      // Role: null,
      // Status: "AC",
      // Title: "工程師"
    },
    auth: new AuthService(),
    ssoUser: {
      currentUser: "",
      currentUserEmail: "",
      accessTokenExpired: false,
      isLoggedIn: false,
    },
  },
  mutations: {
    [Mutations.SET_SSO_USER](context: any, payload: any) {
      context.ssoUser.currentUser = payload.profile.emp_name;
      context.ssoUser.currentUserEmail = payload.profile.name;
      context.ssoUser.accessTokenExpired = payload.expired;
      context.ssoUser.isLoggedIn = payload !== null && !payload.expired;
    },
    [Mutations.SET_USER](state: any, payload: User) {
      state.user = payload;
    },
  },
  actions: {
    [Actions.SSO_LOGIN]() {
      this.state.auth.login();
    },
    [Actions.SSO_LOGOUT]() {
      this.state.auth.logout();
    },
    async [Actions.VERIFY_AUTH](context: any) {
      await this.state.auth
        .getUser()
        .then((user: any) => {
          if (user) {
            context.commit(Mutations.SET_SSO_USER, user);
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
      //ApiService.setHeader();
    },
    async [Actions.GET_User](context: any) {
      var endPoint = config.apiEndPoints.jma + apiEnums.SSOuser.Path;
      var email = context.state.ssoUser.currentUserEmail;

      if (email) {
        // var token = await this.state.auth.getAccessToken();
        await axios
          .get(endPoint)
          .then((response) => {
            // console.log("----------------------------------------");
            // console.log("response: ", response);
            if (response.data) {
              context.commit(Mutations.SET_USER, response.data);
              // console.log(token);
            }
          })
          .catch((error: any) => {
            console.log(error);
            console.log({
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
            });
          });
      }
    },
  },
  getters: {
    getAuth: (state: any) => state.auth,
    [Getters.SSO_USER](context: any) {
      return context.ssoUser;
    },
    [Getters.API_User](context: any) {
      return context.user;
    },
  },
  modules: {
    [hosterModule.name]: hosterModules,
    [participationModule.name]: participationModules,
    [homeModule.name]: homeModules,
    [exposedModule.name]: exposedModules
  },
});
